import React from "react";
import btn from "../../assets/icons/btn-arrow-rigth.svg";
import rocket from "../../assets/img/about/rockets.png";
import { NavLink } from "react-router-dom";

function Companies() {
  const cardCompanies = [
    {
      logo: require("../../assets/logos/logo-forager-media-group.png"),
      style:
        "w-44 2xl:w-full px-2 2xl:px-24 2xl:py-12 hover:scale-110 with-transition",
      name: "forager media group canada",
      location: "Gibsons, British Columbia",
      link: "/companies/forager-media-group",
    },
    {
      logo: require("../../assets/logos/logo-forager-education.png"),
      style:
        "w-40 2xl:w-full 2xl:px-24 2xl:py-11 hover:scale-110 with-transition",
      name: "forager education canada",
      location: "Gibsons, British Columbia",
      link: "/companies/forager-education",
    },
    {
      logo: require("../../assets/logos/logo-forager-financial.png"),
      style:
        "w-60 2xl:w-full md:px-2 2xl:px-16 2xl:py-11 hover:scale-110 with-transition",
      name: "forager financial services canada",
      location: "Gibsons, British Columbia",
      link: "/companies/forager-financial",
    },
  ];
  return (
    <div className="bg-dark-denim">
      <section className="bg-dark-denim md:pb-10 2xl:pb-16">
        <div className="app-forager-international-companies with-curved-bottom bg-no-repeat bg-cover px-0 pt-5">
          <div className="h-48 md:h-44 lg:mt-14 grid place-items-center">
            <h1 className="text-white text-4xl lg:text-6xl">companies</h1>
          </div>
        </div>
        <div className="container mx-auto grid grid-cols-1 lg:grid-cols-2 justify-center items-center gap-x-16 mt-4 relative">
          <img
            src={rocket}
            alt=""
            className="hidden lg:block absolute -top-16 left-24 w-1/3 -rotate-6 xl:-rotate-3 2xl:-rotate-2 mt-8 xl:mt-4"
          />
        </div>
      </section>
      <div>
        <div className="container mx-auto">
          <p className="pt-4 px-4 lg:px-9 pb-14 xl:pb-8 lg:w-4/5 lg:mx-auto lg:text-center text-white">
            Forager International specializes in solutions for the heritage
            sector. Through business partnerships and investments, the services
            available continue to grow in subject and location. We are proud of
            what we are creating and continue to develop new opportunities to
            deepen our relationship with the heritage sector around the world.
          </p>
        </div>
        <div className="pb-14 lg:pb-20 px-4 flex flex-wrap justify-center gap-5">
          {cardCompanies.map((e, i) => (
            <NavLink to={e.link} key={i}>
              <div className="w-[20.6rem] h-56 rounded-xl bg-white grid place-items-center overflow-hidden">
                <img src={e.logo} alt="" className={`mt-auto ${e.style}`} />
                <div className="mt-auto py-3 pl-5 w-full flex justify-between bg-grey">
                  <p className="text-navy-blue font-semibold">
                    {e.name}
                    <span className="pb-1 text-xs block text-dark-denim font-normal">
                      {e.location}
                    </span>
                  </p>
                  <img src={btn} alt="" className="pr-3" />
                </div>
              </div>
            </NavLink>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Companies;
